import { useContext, useEffect } from "react";
import DisableSubmissionStateContext from "../contexts/DisableSubmissionStateContext";
const PropagateDisableSubmissionState = ({ formKey, disableSubmission }) => {
  const { setDisabled } = useContext(DisableSubmissionStateContext);
  useEffect(() => setDisabled(formKey, disableSubmission), [formKey, disableSubmission, setDisabled]);
  return null;
};
export default PropagateDisableSubmissionState;
